import * as React from "react";
import type { SVGProps } from "react";
const SvgReload = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.516 5.157A7 7 0 0 1 12 5a7 7 0 0 1 5.85 3.155l-.502-.226-.912-.41-.82 1.823.91.41 2.58 1.162a1 1 0 0 0 1.322-.502l1.162-2.579.41-.911-1.823-.822-.411.912-.113.25A9 9 0 0 0 12 3q-.981.002-1.905.202a1 1 0 0 0 .421 1.955m-4.42 3.081A6.96 6.96 0 0 0 5 12c0 .606.077 1.192.22 1.75a1 1 0 1 1-1.936.5A9 9 0 0 1 3 12c0-1.804.532-3.486 1.446-4.895l-.295.029-.995.097-.193-1.991.995-.097 2.815-.273a1 1 0 0 1 1.092.899l.274 2.815.096.995-1.99.194-.097-.996zm14.69 5.724a1 1 0 0 0-1.953-.434 7.003 7.003 0 0 1-10.308 4.55l.477-.109.975-.221-.443-1.95-.975.221-2.758.627a1 1 0 0 0-.754 1.196l.626 2.758.222.976 1.95-.443-.221-.976-.076-.334A8.96 8.96 0 0 0 12 21c4.298 0 7.89-3.011 8.785-7.038"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgReload;
